package songwritersnotebook.app.utils

data class WaveformResult(
    val points: List<Float>,
    val durationMillis: Long
)

expect object WaveformGenerator {
    suspend fun generateWaveform(filePath: String): WaveformResult
}
